import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID } from '../utils/Constants'
import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export default {
  getAll,
  getAllForCase,
  get,
  create,
  update,
  deleteTask,
  mergeToAppointment,
}

function getAll(incompleteOnly = false) {
  return wrapFetch(
    fetch(`/api/tasks?incompleteOnly=${incompleteOnly}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  )
}

function getAllForCase(caseNumber, filter) {
  let url = `/api/cases/${caseNumber}/tasks`

  if (filter) {
    url += `?$filter="${encodeURIComponent(filter)}"`
  }

  return wrapFetch(
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  )
}

function get(caseNumber, taskNumber) {
  return wrapFetch(
    fetch(`/api/cases/${caseNumber}/tasks/${taskNumber}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  )
}

function create(taskObj, caseNumber) {
  return wrapFetch(
    fetch(`/api/cases/${caseNumber}/tasks`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(taskObj),
    }),
  )
}

function update(taskObj, caseNumber, taskNumber) {
  return wrapFetch(
    fetch(`/api/cases/${caseNumber}/tasks/${taskNumber}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(taskObj),
    }),
  )
}

async function deleteTask(caseNumber, taskNumber, force = false) {
  const url = force
    ? `/api/cases/${caseNumber}/tasks/${taskNumber}?force=true`
    : `/api/cases/${caseNumber}/tasks/${taskNumber}`

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      Accept: 'application/json',
    },
  })

  if (response.status === 401) {
    localStorage.removeItem(`oidc.user:${COGNITO_AUTHORITY}:${COGNITO_CLIENT_ID}`)
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
    window.location.replace(`/signin?returnTo=${returnTo}`)
    return new Promise(() => {})
  }

  if (response.status === 204) return null

  // Parse the body for both 400 (requiresForce / error) and unexpected statuses
  const body = await response.json().catch(() => ({}))

  if (!response.ok) {
    const err = new Error(body.message || `HTTP ${response.status}`)
    err.requiresForce = body.requiresForce === true
    err.serverMessage = body.message
    throw err
  }

  return body
}

function mergeToAppointment(caseNumber, taskNumber, appointmentNumber, keepNotes) {
  return wrapFetch(
    fetch(`/api/cases/${caseNumber}/tasks/${taskNumber}/merge-to-appointment/${appointmentNumber}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ keepNotes }),
    }),
  )
}
